module.exports = __webpack_public_path__ + "img/IMG_3539_FoamcoreMatted.99ad525e.jpg";